import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";

const routes = [
  {
    href: "",
    imgSrc: "/images/1.jpg",
    price: "From $15",
    name: "Bhimashankar",
    text: "Comfortable cab rides to Bhimashankar with trusted drivers.",
  },
  {
    href: "",
    imgSrc: "/images/2.jpg",
    price: "From $10",
    name: "Mahabaleshwar",
    text: "Relaxing trips to Mahabaleshwar with scenic hill views.",
  },
  {
    href: "",
    imgSrc: "/images/4.webp",
    price: "From $20",
    name: "Mumbai Darshan",
    text: "Explore Mumbai’s top attractions with ease and comfort.",
  },
  {
    href: "",
    imgSrc: "/images/3.jpg",
    price: "From $25",
    name: "Kolhapur",
    text: "Smooth Kolhapur rides for business or family travel.",
  },
];

const TopDestinationSection = () => {
  const sectionStyle = {
    backgroundImage: "url('/img/shape/Bg.png')",
    backgroundRepeat: "no-repeat",
    backgroundPosition: "center",
    backgroundSize: "cover",
    position: "relative",
  };

  return (
    <section
      className=" space- bg-light shape-mockup-wrap"
      style={sectionStyle}
    >
      {/* Background Shapes */}
      <div
        className="shape-mockup d-none d-xl-block spin z-index-negative"
        style={{ position: "absolute", top: "-20%", right: "-8%" }}
      >
        <img src="/img/shape/circle1.png" alt="circle" />
      </div>
      <div
        className="shape-mockup d-none d-xl-block z-index-negative"
        style={{ position: "absolute", bottom: "13%", left: "0%" }}
      >
        <img src="/img/shape/walk.png" alt="shape" />
      </div>

      <div className="container">
        <div className="row justify-content-between align-items-center">
          <div className="col-lg-5 col-md-8">
            <div className="title-area">
              <span className="sec-subtitle">Platinum24 Cabs</span>
              <h2 className="sec-title h1">Popular Routes We Cover</h2>
              <p className="sec-text">
                Discover the most requested routes by our customers. We ensure every trip is comfortable, safe, and on time — whether you're heading to the airport or going out of town.
              </p>
            </div>
          </div>
          <div className="col-auto">
            <div className="sec-btns">
              <button className="icon-btn swiper-prev" type="button">
                <i className="fas fa-chevron-left"></i>
              </button>
              <button className="icon-btn swiper-next" type="button">
                <i className="fas fa-chevron-right"></i>
              </button>
            </div>
          </div>
        </div>

        {/* Swiper Slider */}
        <Swiper
          modules={[Navigation, Autoplay]}
          spaceBetween={20}
          slidesPerView={3}
          autoplay={{ delay: 3000, disableOnInteraction: false }}
          navigation={{
            nextEl: ".swiper-next",
            prevEl: ".swiper-prev",
          }}
          loop={true}
          breakpoints={{
            320: { slidesPerView: 1 },
            576: { slidesPerView: 2 },
            992: { slidesPerView: 3 },
          }}
          className="destinationSlide"
        >
          {routes.map(({ href, imgSrc, price, name, text }, idx) => (
            <SwiperSlide key={idx}>
              <div className="destination-style1">
                <a href={href}>
                  <img src={imgSrc} alt={name} />
                </a>
                <div className="destination-info">
                  <h4 className="destination-name">
                    <a href={href}>{name}</a>
                  </h4>
                  <p className="destination-text">{text}</p>
                </div>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </section>
  );
};

export default TopDestinationSection;
